
// Vue
import {Options, Vue} from "vue-class-component";

// Store
import store from "@/store/index";

// Models
import {AppAdministratorResourcesExercisesListIndex} from "@/models/app/administrator/resources/exercises/list/index";
import {ResponseIndex} from "@/models/response";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import AppAdministratorResourcesExercisesListFormLookupIndexVue from "@/views/app/administrator/resources/exercises/list/form/lookup.vue";
import AppAdministratorResourcesExercisesListFormCreateIndexVue from "@/views/app/administrator/resources/exercises/list/form/create.vue";
import AppAdministratorResourcesExercisesListFormUpdateIndexVue from "@/views/app/administrator/resources/exercises/list/form/update.vue";
import AppAdministratorResourcesExercisesListFormRemoveIndexVue from "@/views/app/administrator/resources/exercises/list/form/remove.vue";

// Services
import {getRequest} from "@/services/api/request";

@Options({
  components: {
    ElRow,
    ElCol,
    AppAdministratorResourcesExercisesListFormLookupIndexVue,
    AppAdministratorResourcesExercisesListFormCreateIndexVue,
    AppAdministratorResourcesExercisesListFormUpdateIndexVue,
    AppAdministratorResourcesExercisesListFormRemoveIndexVue,
  },
})
export default class AppAdministratorResourcesExercisesListIndexVue extends Vue {
  isLoading: boolean | null = false;

  exercises: Array<AppAdministratorResourcesExercisesListIndex> = [];

  async getExercises(): Promise<void> {
    this.isLoading = true;
    await getRequest({
      uri: `/administration/exercises`,
      formData: {
        organization_id: store.getters.getOrganizationMember.organization_id,
      },
      isProtected: true,
    }).then((r: ResponseIndex) => {
      if (r.data) {
        this.exercises = r.data;
      }
    });
    this.isLoading = false;
  }

  async created(): Promise<void> {
    await this.getExercises();
  }
}
